import { Children, React, useEffect, useLayoutEffect, useState } from "react";
import { Flex, Space, Splitter, Typography, ConfigProvider, theme, Layout, Menu, Button } from 'antd';
import TzolkinPage from './TzolkinPage'
import ruRU from 'antd/locale/ru_RU';
import enUS from 'antd/locale/en_US';
import {SunOutlined} from '@ant-design/icons';
import css from './App.css';
import Logo from './Logo';
import maya from './js/maya';
import translations from "./translations";
import AppsPage from "./AppsPage";
import AboutPage from "./AboutPage";
import NewsPage from "./NewsPage";

const { Header, Content, Footer } = Layout;
const {Text} = Typography;

function App() {
  const [loc, setLoc] = useState(translations);
  const [lang, setLang] = useState("ru");
  const locale = lang == 'ru' ? ruRU : enUS;
  const [currentTheme, setTheme] = useState("dark");
  const [page, changePage] = useState("home");
  useEffect(() => {
    var t;
    const fetchTranslations = async () => {
      await fetch("/data/translations_"+lang+".json")
        .then(responce => responce.json())
        .then(responce => {
          setLoc(responce);
        })
        .catch(e => console.log(e));
    }
    if(lang == 'ru') {
      setLoc(translations);
    } else {
      fetchTranslations();
    }
  });
  const mainMenu = [
    {
      key: "home",
      label: loc.tzolkin
    },/*
    {
      key: "news",
      label: loc.news
    },*/
    {
      key: "apps",
      label: loc.apps
    },
    {
      key: "about",
      label: loc.about
    }
  ]
  const optionsMenu = [
    {
      key: "setlang",
      label: "Lang",
      children: [
        {
          key: "en",
          label: "English"
        },
        {
          key: "ru",
          label: "Русский"
        }
      ]
    }
  ]
  const changeTheme = () => {
    if(currentTheme == "light") {
      setTheme("dark");
    } else if(currentTheme == "dark") {
      setTheme("light");
    }
  }
  if(currentTheme == "dark") {
    document.body.style.backgroundColor = "#000";
  } else {
    document.body.style.backgroundColor = "#fff";
  }
  return (
    <ConfigProvider locale={locale} theme={{
      colorPrimary: '#f86700ff',
      algorithm: currentTheme == "dark"?theme.darkAlgorithm:theme.defaultAlgorithm
    }}>
        <Layout style={{minWidth: 600, minHeight: window.screen.availHeight-200}}>
          <Header style={{ display: 'flex', alignItems: 'center' }}>
            <div className="demo-logo" style={{ display: 'flex', alignItems: 'center' , paddingRight: '1em'}}>
              <Logo/>
            </div>
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={['home']}
              items={mainMenu}
              style={{ flex: 1, minWidth: 0 }}
              onClick={({key}) => { changePage(key) }}
            />
            <Menu
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={lang}
              items={optionsMenu}
              style={{ flex: 1, minWidth: 0, justifyContent: 'flex-end'}}
              onClick={({key}) => { setLang(key) }}
            />
            <Button type="text" style={{color: "white"}} onClick={changeTheme} icon={<SunOutlined />} shape="circle"></Button>
          </Header>
          <Layout>
            <Content>
              {page==="home"?(<TzolkinPage lang={lang} locale={loc}/>):""}
              {page==="apps"?(<AppsPage lang={lang} locale={loc}/>):""}
              {page==="news"?(<NewsPage lang={lang} locale={loc}/>):""}
              {page==="about"?(<AboutPage lang={lang} locale={loc}/>):""}
            </Content>
          </Layout>
          <Footer style={{textAlign: "center"}}>
            <Text>&copy;sharap.software 2015-{(new Date()).getFullYear()}</Text>
          </Footer>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
